module.exports = __webpack_public_path__ + "static/media/la-solid-900.79be4e9f.svg";